'use client';

import { text as sharedText } from '@shared/text';
import { useUIStore } from '@/src/store/useUIStore';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@ui/components/alert-dialog';

export function GlobalConfirmDialog() {
  const confirmDialog = useUIStore((state) => state.confirmDialog);
  const setConfirmDialog = useUIStore((state) => state.setConfirmDialog);

  const handleClose = (open: boolean) => {
    if (!open) {
      setConfirmDialog({
        isOpen: false,
        title: '',
        message: '',
        onConfirm: () => {},
      });
    }
  };

  const handleConfirm = () => {
    confirmDialog.onConfirm();
    handleClose(false);
  };

  return (
    <AlertDialog open={confirmDialog.isOpen} onOpenChange={handleClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{confirmDialog.title}</AlertDialogTitle>
          <AlertDialogDescription>{confirmDialog.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{sharedText.cancel}</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm}>{sharedText.confirm}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
